module.exports = __webpack_public_path__ + "img/logo-wenjuan-active1.de518847.png";